import { type DateRange, Location, MediaStatus, MediaType, locationName } from '@cobliteam/common-types';

import { getTime } from '@cobliteam/utils/date';

import { useGetMediaRequestList } from '@cobliteam/hooks/src/useCamera/useCameraMedia';

import { HintPopup } from '@cobliteam/base-components';
import { type BadgeSidebarType, badgeColors } from '@cobliteam/base-components/src/BadgeSidebar/Badge';

import { SidebarItemDropdownEntry } from '../SidebarItemDropdownEntry/SidebarItemDropdownEntry';
import * as styles from '../styles';

export interface SidebarMediaRequestItemProps {
  currentLocation: Location;
  badgeType?: BadgeSidebarType;
}

const now = new Date();
const then = new Date(now);
then.setDate(now.getDate() - 7);

const SidebarMediaRequestItem = ({ currentLocation, badgeType }: SidebarMediaRequestItemProps) => {
  const requestPeriod: DateRange = {
    end: getTime(now, 'end'),
    start: getTime(then, 'start'),
  };

  const { data, isLoading: isLoadingMedias } = useGetMediaRequestList({
    page: 0,
    size: 1,
    mediaTypes: [MediaType.FOOTAGE_VIDEO, MediaType.TIMELAPSE],
    mediaStatus: [MediaStatus.NEW],
    requestedAt: requestPeriod,
  });

  const renderNewMediaLength = () => {
    const newMedias = data?.totalElements ?? 0;

    return (
      <>
        {!isLoadingMedias && newMedias ? (
          <HintPopup title='Vídeos não assistidos nos últimos 31 dias' enabled arrow placement='top'>
            <div className=' flex size-6 items-center justify-center rounded-full bg-warning-10 text-xs'>{newMedias > 99 ? '99+' : newMedias}</div>
          </HintPopup>
        ) : null}
      </>
    );
  };

  return (
    <SidebarItemDropdownEntry
      location={Location.CAMERA_REQUESTS}
      active={
        [Location.CAMERA_REQUESTS, Location.CAMERA_REQUESTS_FAVORITES.replace(':view', 'favorites') as Location].includes(currentLocation) ||
        currentLocation.includes('/camera/requests')
      }
    >
      <div id='sidebar--coblicam-video' className='flex flex-row items-center gap-5'>
        {locationName[Location.CAMERA_REQUESTS]}
        {badgeType && <div className={styles.badgeCircle(badgeColors[badgeType])} />}
        {renderNewMediaLength()}
      </div>
    </SidebarItemDropdownEntry>
  );
};
export default SidebarMediaRequestItem;
